/* eslint-disable no-console */
// https://medium.com/@dougallrich/give-users-control-over-app-updates-in-vue-cli-3-pwas-20453aedc1f2

import {
	register
} from 'register-service-worker'

if (process.env.NODE_ENV === 'production' && window.location.protocol == 'https:') {
	register(`${process.env.BASE_URL}sw.js`, {
		ready() {
			console.log('OnePipe is being served from cache by a service worker')
		},
		registered() {
			console.log('Service worker has been registered.')
		},
		cached() {
			// console.log('Content has been cached for offline use.')
		},
		updatefound() {
			// console.log(reg);
			// if (caches) {
			// 	console.log('Cache is present');
			// }
		},
		updated() {
			console.log('New content is available; please refresh.')
			// registration.update();
			/* setTimeout(() => {
				window.location.reload(true)
			}, 1000) */

			// caches.keys().then(function (names) {
			// 	for (let name of names) caches.delete(name);
			// });

		},
		offline() {
			// console.log('No internet connection found. App is running in offline mode.')
		},
		error(error) {
			console.error('Error during service worker registration:', error)
		}
	})
}